// extracted by mini-css-extract-plugin
export default {"container":"S01_container__An0FI","limiter":"S01_limiter__0yjes","title":"S01_title__b5Dak","text":"S01_text__rWMNn"};